import { VakAnswerOption, VakCategoryInfo } from "../typings/vak";

const getAnswerOptions = (): VakAnswerOption[] => {
  return [
    {
      score: 1,
      label: "Sangat Tidak Setuju",
    },
    {
      score: 2,
      label: "Tidak Setuju",
    },
    {
      score: 3,
      label: "Netral",
    },
    {
      score: 4,
      label: "Setuju",
    },
    {
      score: 5,
      label: "Sangat Setuju",
    },
  ];
};

const getAnswerOptionLabels = (score: number | null): VakAnswerOption|undefined => {
  return getAnswerOptions().find(a => a.score === score);
};

const VAK_CATEGORIES: VakCategoryInfo[] = [
  {
    type: "V",
    name: "Visual",
    title: "Visual",
    description: "",
    color: "#FF6384",
  },
  {
    type: "A",
    name: "Auditory",
    title: "Auditory",
    description: "",
    color: "#36A2EB",
  },
  {
    type: "K",
    name: "Kinesthetic",
    title: "Kinesthetic",
    description: "",
    color: "#FFCE56",
  },
];

const formatBold = (text: string | undefined): string => {
  if (!text) return "";
  return text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
};

export { getAnswerOptions, getAnswerOptionLabels, VAK_CATEGORIES, formatBold };